// Module with the same interface as the core aphrodite module,
// except that styles injected do not automatically have !important
// appended to them.
//
'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

var _inject = require('./inject');

var _indexJs = require('./index.js');

var css = function css() {
  for (var _len = arguments.length, styleDefinitions = Array(_len), _key = 0; _key < _len; _key++) {
    styleDefinitions[_key] = arguments[_key];
  }

  var useImportant = false; // Don't append !important to style definitions

  return (0, _inject.injectAndGetClassName)(useImportant, styleDefinitions);
};

exports.StyleSheet = _indexJs.StyleSheet;
exports.StyleSheetServer = _indexJs.StyleSheetServer;
exports.StyleSheetTestUtils = _indexJs.StyleSheetTestUtils;
exports.css = css;